export const PRE_SCREENING_INVITE_TYPE = "Pre-Screening";

export function isPreScreeningInviteType(
  appInviteType: string | null | undefined,
): boolean {
  return appInviteType === PRE_SCREENING_INVITE_TYPE;
}
